import React, { useState } from 'react';
import { Checkbox, TextField, Button, Select, MenuItem, FormControl, InputLabel, Typography, Paper, Box, IconButton as Divider, FormControlLabel, Grid  } from '@mui/material';
import useStyles from '../../../../styles/global-mui.js';
import { useDispatch } from 'react-redux';
import { discipline_all, getActualSeason, season_all } from '../../../../bdd/bddSTUB.js';
import { checkExistingCompetition } from '../../../../api/index.js';
import { getUserProvider } from '../../../../actions/auth.js';
import SelectGroupProvider from '../../../../dsasComponents/SelectGroupProvider.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { createCompetition, deleteCompetition, updateCompetition } from '../../../../actions/competitions.js';
import CompetitionCheckModal from './CompetitionCheckModal.js';
import { confirmActionNotification } from '../../../../actions/notifications.js';
import { useNotifications } from '../../../../v2/notifications/NotificationManager.js';
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import ImageHandlerTool from '../../../components/ImageHandlerTool.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { usePermissions } from '../../../../permissions/usePermissions.js';

const defaultCompetitionData = {
    name : '', 
    discipline : '',

    photo : '',

    enableAPI : false, 
    particularGoalAverage : false, 
    nbDays : '', 
    nbTeamFinalPhase : '',
    season : getActualSeason(), 
    provider : getUserProvider()
}

const FormCompetition = ({ competition = defaultCompetitionData, onValidate = () => {} }) => {

    const navigate = useNavigate()
    const location = useLocation()
    const {addNotification} = useNotifications()

    const competitionFromState = location.state?.copyCompetition || competition;
    const [competitionData, setCompetitionData] = useState(competitionFromState);

    const dispatch = useDispatch();

    const [existingCompetitions, setExistingCompetitions] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCheckComplete, setIsCheckComplete] = useState(competition._id); // Gérer l'étape de vérification

    const [isProcessing, setIsProcessing] = useState(false)

    const { getPermission } = usePermissions();
    const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);
    
    // Gérer la soumission du formulaire
    const handleSubmit = (e) => {

        setIsProcessing(true)

        const sanitizedCompetitionData = { ...competitionData };

        // Créer ou mettre à jour le joueur
        if (competition._id) {
            dispatch(updateCompetition(competition._id, sanitizedCompetitionData));
        } else {
            dispatch(createCompetition(sanitizedCompetitionData));
        }

        const previousURL = location.state?.from || '/sports/competitions'; // Redirige par défaut à la racine si aucune URL précédente
        setTimeout(() => {
            setIsProcessing(false); 
            onValidate();
            clearForm(); 
            navigate(previousURL)}, 
            1000)
    };

    // Gérer les changements dans les champs du formulaire
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCompetitionData((prev) => ({ ...prev, [name]: value }));
    };

    const handleChangeApiWidget = () => {
        setCompetitionData(s => ({...s, enableAPI: !s.enableAPI}));
    };

    const handleChangeGoalAverage = () => {
        setCompetitionData(s => ({...s, particularGoalAverage: !s.particularGoalAverage}));
    };

    const isValidForm = () => {
        return isValidCheckExistingCompetition() && competitionData.provider
    }

    // Réinitialiser le formulaire
    const clearForm = () => {
        setCompetitionData(defaultCompetitionData);
        setIsCheckComplete(competition._id);
        setIsModalOpen(false);
    };

    const isValidCheckExistingCompetition = () => {
        return competitionData.name && competitionData.discipline && competitionData.season
    }

    const handleCheckExistingCompetition = async () => {
        const { name, discipline, season } = competitionData;
        const results = await checkExistingCompetition({ name, discipline, season });
    
        const similarCompetitions = results.data
        
        if(!similarCompetitions.length){
          setIsCheckComplete(true);
          setIsModalOpen(false);
        }else{
          setExistingCompetitions(similarCompetitions);
          setIsModalOpen(true); // Ouvrir la modal une fois que les résultats sont prêts
        }
    };

    const handleSelectOtherCompetition = (competition) => {
        // Remplir les champs avec les informations de la competition sélectionnée
        setCompetitionData((prev) => ({
          ...prev,

          name: competition.name,
          discipline: competition.discipline,
          season: competition.season,

          enableAPI: competition.enableAPI,
          particularGoalAverage: competition.particularGoalAverage,
          nbDays: competition.nbDays,
          nbTeamFinalPhase: competition.nbTeamFinalPhase,
          
          //TODO LATER - handle logo
          //photoUrl: competition.photoUrl,

          thirdPartyId: competition.thirdPartyId,
          thirdPartyEntityId: competition.thirdPartyEntityId,
          // Ne pas inclure _id, provider
        }));
    
        setIsCheckComplete(true); // L'utilisateur a passé la vérification
        setIsModalOpen(false);
    };

    const handleConfirmNone = () => {
        setIsCheckComplete(true); // Marquer que l'utilisateur a bien vérifié
        setIsModalOpen(false);
    };

    const handleConfirmSubmit = (e) => {
    
        e.preventDefault()
    
        dispatch(confirmActionNotification("Êtes-vous sûr de vouloir "+ (competition._id ? "modifier" : "créer")+" la compétition ?", handleSubmit))
    
    }

    const handleDelete = (e) => {
         e.preventDefault()

         dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer la compétition ?", () => {
            dispatch(deleteCompetition(competition._id, (id) => {addNotification({
                title : "Suppression", 
                type : "success", 
                description : "La competition "+ competition.name+" a été supprimée."
            })
            const previousURL = location.state?.from || '/sports/competitions';
            navigate(previousURL)
            }))
        })) 
    }

    const classes = useStyles();

    return (
        <Box sx={{ paddingLeft: 3, paddingRight: 3, textAlign : 'center' }}>
            <form onSubmit={handleConfirmSubmit} autoComplete="off">
                {/*PAGE TITLE*/}
                <Box className='centered-medium-wrapper'>
                    <h1 className='page-title'>{competition._id ? 'Editer' : 'Créer'} une compétition</h1>
                </Box>
                <Box className='large-separator'></Box>
                <Box className='small-padding'></Box>

                 <Box className='padding-wrapper'>
                    <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
                        {providerPermission?.allowed && (
                        <Grid item xs={12} sm={12} md>
                            {/* Groupe (Provider) */}
                            <SelectGroupProvider value={competitionData.provider} onChange={(e) => setCompetitionData((prev) => ({ ...prev, provider: e.target.value }))} className={classes.customInput} />             
                        </Grid>
                        )}
                        <Grid item xs={12} sm={12} md>
                            {/* Nom */}
                            <TextField className={classes.customInput} 
                            name="name" label="Nom" error={!competitionData.name} fullWidth value={competitionData.name} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={12} sm={12} md>
                            {/* Discipline */}
                            <FormControl className={classes.customInput} fullWidth error={!competitionData.discipline}>
                                <InputLabel>Discipline</InputLabel>
                                <Select name="discipline" value={competitionData.discipline}   onChange={handleChange} label={"Discipline"}>
                                    {discipline_all.map((discipline) => (
                                    <MenuItem key={discipline._id} value={discipline._id}>
                                        {discipline.name}
                                    </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>            
                        </Grid>
                        <Grid item xs={12} sm={12} md>
                            {/* Season */}
                            <FormControl className={classes.customInput} fullWidth error={!competitionData.season}>
                                <InputLabel>Saison</InputLabel>
                                <Select name="season" value={competitionData.season} onChange={handleChange} label={"Saison"}>
                                    {season_all.map((season) => (
                                    <MenuItem key={season._id} value={season._id}>
                                        {season.name}
                                    </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>              
                        </Grid>
                    </Grid>
                </Box>


                {!isCheckComplete && <Box className='centered-medium-wrapper'>
                    <DsasButton label="Vérifier l'existence de la compétition" onClick={handleCheckExistingCompetition} variant = 'alternative' disabled={!isValidCheckExistingCompetition()}/>
                </Box>}

                {/* Modal de vérification des doublons */}
                <CompetitionCheckModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={existingCompetitions}
                onSelectOtherCompetition={handleSelectOtherCompetition}
                onConfirmNone={handleConfirmNone}
                />

                {/* Formulaire complet, mais désactivé tant que la vérification n'est pas terminée */}
                {isCheckComplete && 
                <>
                <Box className='small-padding'></Box>
                <Box className='large-separator'></Box>
                <Box className='small-padding'></Box>
                <Box>
                    <Box className='centered-medium-wrapper'>
                        {/* Image */}
                        <ImageHandlerTool type='avatar' 
                        initialImage={competition.photoUrl} 
                        onImageSave={(image) => setCompetitionData(prev => ({ ...prev, photo: image }))} 
                        displayImageLabel={false} 
                        uploadButtonLabel='Editer le logo'
                        />
                    </Box>
        
                    <Box className='large-separator'></Box>

                <Box className='centered-medium-wrapper'>
                    <Typography variant='h1' className={classes.customSubtitle}>
                                Informations
                        </Typography>
                </Box>

                <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}} className='medium-padding-left medium-padding-right'>
                    <Can permission={PERMISSIONS.SPORT_COMPETITION_CREATE_INPUT_NBDAYS}>
                        <Grid item xs={12} sm={12} md>
                            <TextField
                                className={classes.customInput}
                                name="nbDays"
                                label="Nombre de journées"
                                fullWidth
                                value={competitionData.nbDays || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Can>
                    <Can permission={PERMISSIONS.SPORT_COMPETITION_CREATE_INPUT_NBTEAMS}>
                        <Grid item xs={12} sm={12} md>
                            {/* nbTeamFinalPhase */}
                            <TextField
                                className={classes.customInput}
                                name="nbTeamFinalPhase"
                                label="Nombre d'équipes en phase finale"
                                fullWidth
                                value={competitionData.nbTeamFinalPhase || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Can>
                </Grid>
                <Box 
                className="centered-medium-wrapper"
                onClick={handleChangeGoalAverage}
                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                >
                    <FontAwesomeIcon
                        icon={competitionData.particularGoalAverage ? faCircleCheck : faCircle }
                        style={{ color: 'var(--color-blue-secondary)', fontSize: 'larger' }}
                    />
                    <Typography className={classes.customTypo} sx={{ paddingLeft: '1rem' }}>Goalaverage particulier</Typography>
                </Box>
                <Box className='small-padding'></Box>
                <Box className='large-separator'></Box>

                <Can permission={PERMISSIONS.AREA_THIRDPARTY}>
                    <Box className='medium-padding'>

                        <Typography variant='h1' className={classes.customSubtitle}>
                            Identification externe
                        </Typography>
    
                        <Box className='small-padding'></Box>   
                            <Grid container spacing={1.5}>
                                        <Grid item xs={6} sm={6} md>
                                            {/* Id externe */}
                                            <TextField 
                                            className={classes.customInput}
                                            name="thirdPartyEntityId" label="Id externe" fullWidth value={competitionData.thirdPartyEntityId || ''} onChange={handleChange} />   
                                        </Grid>
                                        <Grid item xs={6} sm={6} md>
                                            {/* Origine id externe */}
                                            <TextField 
                                            className={classes.customInput}
                                            name="thirdPartyId" label="Origine Id externe" fullWidth value={competitionData.thirdPartyId || ''} onChange={handleChange} />  
                                        </Grid>
                            </Grid>
                        <Box className='small-padding'></Box>
                    </Box>   
                    <Box className='large-separator'></Box>      
                </Can>

                {/*Subscription*/}
                <Can permission={PERMISSIONS.SPORT_COMPETITION_CREATE_AREA_VISIBLEAPI}>
                    <Box className='centered-column-wrapper medium-wrapper'>
                        <Box className='centered-wrapper'>
                            <Typography variant='h1' className={classes.customSubtitle}>
                                        Options d'API
                                </Typography>
                        </Box>
                        
                            {/* enableAPI */}
                            <Box 
                                className="centered-medium-wrapper"
                                onClick={handleChangeApiWidget}
                                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon
                                        icon={competitionData.enableAPI ? faCircleCheck : faCircle }
                                        style={{ color: 'var(--color-blue-secondary)', fontSize: 'larger' }}
                                    />
                                    <Typography className={classes.customTypo} sx={{ paddingLeft: '1rem' }}>Visible API Widget</Typography>
                                </Box>

                            {/* <FormControlLabel
                                className={classes.customInput}
                                control={
                                    <Checkbox
                                    checked={competitionData.enableAPI}
                                    onChange={handleCheck}
                                    name="enableAPI"
                                    />
                                }
                                label="Visible API Widget"
                                /> */}
                        
                    </Box>
                </Can>

                {/* Boutons */}
                <Box className='medium-padding centered-wrapper'>
                    <DsasButton type='submit' label="Valider" variant = 'alternative' disabled={!isValidForm()} />
                    <Box className='small-padding'></Box>
                    {competition._id &&
                    <Can permission={PERMISSIONS.SPORT_COMPETITION_CREATE_BUTTON_DELETE}>
                        <DsasButton icon={faTrashCan} label="Supprimer" variant = 'secondary' onClick={handleDelete} />
                    </Can> 
                    }
                </Box>

                </Box>
                </>
                }

            </form>
        </Box>
    );

};

export default FormCompetition;